import { matchPath, useLocation } from 'react-router';

export const useActiveDocumentTemplateId = () => {
  const { pathname } = useLocation();
  const res = matchPath(pathname, {
    path: '/templates/documents/:templateId',
    exact: true,
  });
  const templateId = (res?.params as any)?.templateId;
  const docId = parseInt(templateId, 10);

  return docId;
};
